export const OPEN_LICENCE_MANAGEMENT_TRANSACTION =
	'LICENCE_MANAGEMENT.OPEN_LICENCE_MANAGEMENT_TRANSACTION';
